{
  "browserNotSupported": {
    "title": "Modul konnte nicht geladen werden",
    "text": "Um dieses Modul zu verwenden wechseln Sie bitte zu einem aktuellen Browser."
  },
  "main": {
    "more": "Weiteres Zubehör",
    "findMore": "Finden Sie hier, in unserem umfangreichen Angebot, Zubehör zur Nach-/Umrüstung und Aufwertung Ihres Fahrzeuges. Das von Ihnen ausgewählte Zubehör wird, zusammen mit der Fahrzeuganfrage, an Ihren {{brand}} Partner gesendet.",
    "topOffers": "TOP Angebote",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Artikel",
    "noArticleFound": "0 Artikel",
    "oemHint": "Passendes Zubehör für Ihren {{brand}} jetzt auswählen!",
    "noBrand": "Passendes Zubehör für Ihr Fahrzeug jetzt auswählen!",
    "outOfOrder": "Leider stehen zur Zeit keine Produkte zu Verfügung.<0/>Wir aktualisieren derzeit unseren Zubehör-Katalog.<0/>Bitte besuchen Sie uns zu einem späteren Zeitpunkt wieder.",
    "nextSlide": "Weiter",
    "prevSlide": "Zurück"
  },
  "cart": {
    "add": "Der Artikel wurde zu Ihrem Fahrzeug hinzugefügt",
    "fullPrice": "Preis Fahrzeug und Zubehör",
    "priceWithoutCar": "Preis Zubehör"
  },
  "navigation": {
    "zoom": "Vergrößern",
    "toggleSearch": "Suche umschalten",
    "cart": "Warenkorb",
    "cartDelete": "Artikel aus dem Warenkorb entfernen",
    "vehicle": "Gewähltes Fahrzeug",
    "maxBookmarksReached": "Sie können maximal 15 Produkte auswählen",
    "filter": {
      "toggleFilter": "Filter umschalten",
      "topProducts": "TOP Angebote",
      "reset": "Filter zurücksetzen",
      "ready": "Fertig",
      "show": "Ergebnisse zeigen"
    },
    "searching": {
      "submit": "Suchen",
      "close": "Schließen",
      "placeholder": "Passendes Zubehör finden ...",
      "suggestions": "Suchvorschläge",
      "categories": "Kategorien",
      "products": "Produkte",
      "productCount": "{{count}} Produkt",
      "productCount_other": "{{count}} Produkte",
      "showAll": "{{count}} Ergebnis anzeigen",
      "showAll_other": "Alle {{count}} Ergebnisse anzeigen",
      "expand": "Erweiterte Suche",
      "show": "Ergebnisse anzeigen",
      "found": {
        "withCategory": "Suchergebnisse für \"{{fuzzy}}\" in der Kategorie \"{{category}}\"",
        "withOutCategory": "Suchergebnisse für \"{{fuzzy}}\" aus allen Kategorien"
      }
    },
    "share": "Teilen",
    "back": "Zurück",
    "details": "Details",
    "add": "Hinzufügen",
    "remove": "Entfernen",
    "close": "Schließen",
    "filtern": "Filter",
    "closeFilter": "Filter schließen"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Zum Bild {{number}} springen"
    },
    "articleNumber": "Artikelnummer",
    "relatedArticle": "Andere Kunden interessierten sich für:",
    "brand": "Marke",
    "priceBox": {
      "withVatAndMounting": "inkl. Montage und MwSt.",
      "withVat": "inkl. MwSt.",
      "recommendedRetailPrice": "ursprünglich",
      "historicMinimalPurchasePrice": "30-Tage-Tiefstpreis",
      "priceDetails": "Detailangaben zum Preis",
      "priceDetailsHeadline": "Details zum Preis für diesen Artikel",
      "priceToday": "Preis für diesen Artikel heute",
      "priceDetails30Days": "Niedrigster Preis in den 30 Tagen vor der Preisänderung",
      "close": "Schließen",
      "addItem": "Hinzufügen",
      "removeItem": "Entfernen"
    },
    "infoBox": {
      "description": "Beschreibung",
      "vehicles": "Passend für folgende Modelle",
      "empty": "Für dieses Produkt gibt es keine speziellen Fahrzeugzuordnungen.",
      "contacts": "Hersteller"
    },
    "contacts": {
      "manufacturer-contact": "Kontakt-Information Hersteller",
      "responsible-contact": "Verantwortliche Person innerhalb der EU",
      "trademark": "Marke"
    }
  },
  "productList": {
    "oemHint": "Originales Zubehör für Ihren {{brand}}"
  }
}
